module.exports = __webpack_public_path__ + "static/gunkul-124a7bd8cab6683d79aae99e7c952516.svg";